import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GarantieDetail } from "src/app/parametrage/core/model/garanties/GarantieDetail";
import { GarantieMetadata } from "src/app/parametrage/core/model/garanties/GarantieMetadata";
import { GarantieService } from "src/app/parametrage/core/service/garantie.service";

@Component({
  selector: "app-item-detail",
  templateUrl: "./item-detail.component.html",
  styleUrls: ["./item-detail.component.scss"],
})
export class ItemDetailComponent implements OnInit {
  garantie: GarantieDetail;
  garantieMetadatas: GarantieMetadata[];
  requestId: number;

  constructor(
    public activeModal: NgbActiveModal,
    private _garantieService: GarantieService
  ) {}

  ngOnInit() {
    this.getGarantieMetadatas(this.garantie.id);
  }

  getGarantieMetadatas(garantieId) {
    this._garantieService.getGarantieMetadatas(garantieId).subscribe((data) => {
      this.garantieMetadatas = data;
    });
  }
}
